import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { RmpvPassagemMensalService } from './service/rmpv-passagem-mensal.service';
import { TotalizadorGrafico } from './totalizador-grafico';


declare var $: any;

@Component({
  selector: 'app-rmpv-passagem-mensal',
  templateUrl: './rmpv-passagem-mensal.component.html',
  styleUrls: ['./rmpv-passagem-mensal.component.css']
})
export class RmpvPassagemMensalComponent extends ListaBase implements OnInit {

  objTranslateAPI = {
    "Cliente": "rmpv.passagem.cliente",
    "Garantia": "rmpv.passagem.garantia",
    "Funilaria e Pintura": "rmpv.passagem.funilariaPintura",
    "Acessório": "rmpv.passagem.acessorio",
    "Retorno": "rmpv.passagem.retorno",
    "Recall": "rmpv.passagem.recall",
    "Motos usadas": "rmpv.passagem.motosUsada",
    "Outras Internas": "rmpv.passagem.outraInterna",
    "Cortesia": "rmpv.passagem.cortesia",
    "Revisão": "rmpv.passagem.revisao",
    "Seguro/Franquia": "rmpv.passagem.seguroFranquia",
    "Outras": "rmpv.passagem.outra",
    "PDI": "rmpv.passagem.pdi"
  };

  arrayTranslateChart = [{ categoria: "Cliente", chave: "rmpv.passagem.cliente" },
  { categoria: "Garantia", chave: "rmpv.passagem.garantia" },
  { categoria: "Funilaria e Pintura", chave: "rmpv.passagem.funilariaPintura" },
  { categoria: "Acessório", chave: "rmpv.passagem.acessorio" },
  { categoria: "Motos usadas", chave: "rmpv.passagem.motosUsada" },
  { categoria: "Carros usados", chave: "rmpv.passagem.carrosUsado" },
  { categoria: "Outras Internas", chave: "rmpv.passagem.outraInterna" },
  { categoria: "Cortesia", chave: "rmpv.passagem.cortesia" },
  { categoria: "Revisão", chave: "rmpv.passagem.revisao" },
  { categoria: "Seguro/Franquia", chave: "rmpv.passagem.seguroFranquia" },
  { categoria: "Outras", chave: "rmpv.passagem.outra" },
  { categoria: "Retorno", chave: "rmpv.passagem.retorno" },
  { categoria: "Recall", chave: "rmpv.passagem.recall" },
  { categoria: "PDI", chave: "rmpv.passagem.pdi" }
  ];

  carregando = false;
  categorias: string[] = [];
  totalGeral: any;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { display: true }
  };

  public barChartLabels: string[] = [];
  public barChartLabelsCache: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];
  public barChartColors: any[] = [];

  parametrosFiltro: any;
  valoresMarcasOriginal;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query


  constructor(service: RmpvPassagemMensalService,
    toast: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService) {
    super(service, toast, router);
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);
      this.carregarFiltrosParametros();
    });

    this.getTranslateChart();

  }

  ngOnInit() {
    this.buscar();
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const firstData = new Date();
      this.InicialData = firstData.getFullYear() + '-' + ("0" + (firstData.getMonth() + 1)).slice(-2) + '-' + '01';
    } else {
      const now = new Date(dataInicial);
      this.InicialData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const lastData = new Date();
      this.FinalData = lastData.getFullYear() + '-' + ("0" + (lastData.getMonth() + 1)).slice(-2) + '-' + lastData.getUTCDate();
    } else {
      const now = new Date(dataFinal);
      this.FinalData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }

    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getDados(res: any): any {
    if (res.meses.length === 0) {
      return res.meses;
    }

    this.totalGeral = {};
    this.totalGeral.marcas = [];

    this.carregarTipos(res.meses[0].marcas[0]);

    this.calcularTotaisMensais(res);

    this.calcularTotalGeral();

    this.carregando = false;

    return res.meses;
  }

  private calcularTotalGeral() {
    const total = this.criarTotalizador(this.totalGeral.marcas[0], 'Total', 0);
    this.totalGeral.marcas.forEach(marca => {
      this.totalizarCategorias(marca);
      this.totalizarMarcas(marca, total);
    });

    this.carregarGraficos(this.totalGeral.marcas);

  }

  private calcularTotaisMensais(res: any) {
    res.meses.forEach(mes => {
      const totalMes = this.criarTotalizador(res.meses[0].marcas[0], 'Total', 0);
      this.totalizarPorMes(mes, totalMes);
    });
  }

  private totalizarPorMes(mes: any, totalMes: any) {
    mes.marcas.forEach(marca => {
      this.somarTotalGeralPorMarca(marca);
      this.totalizarCategorias(marca);
      this.totalizarMarcas(marca, totalMes);
    });

    this.totalizarCategorias(totalMes);
  }

  carregarGraficos(lista: any[]) {
    const grafico = new TotalizadorGrafico();

    grafico.processar(lista);

    this.barChartLabels = grafico.getLabels();
    this.barChartType = grafico.getTipo();
    this.barChartLegend = grafico.getLegenda();
    this.barChartData = grafico.getDados();
    this.barChartColors = grafico.getColors();
  }
  //************** Sublinha o label da marca no grafico quando o item fica desativado************* */
  toogleLabelJaguar() {
    $('.fontJaguar').toggleClass('active');
  }

  toogleLabelLandRover() {
    $('.fontLandRover').toggleClass('active');
  }

  /*************************************************************************************************/

  totalizarMarcas(marca: any, total: any) {
    marca.dados.forEach(element => {
      const index = total.dados.findIndex((item) => element.id === item.id);
      total.dados[index].total += element.total;
    });
  }

  criarTotalizador(objeto: any, descricao: string, id: number): any {

    const total: any = {};
    total.dados = [];

    objeto.dados.forEach(element => {
      const categoria: any = {};
      for (const chave in element) {
        if (element.hasOwnProperty(chave)) {
          categoria[chave] = element[chave];
        }
      }
      categoria.total = 0;
      total.dados.push(categoria);
    });

    total.id = id;
    total.marca = descricao;

    return total;
  }

  somarTotalGeralPorMarca(marca: any) {

    let item: any;

    const index = this.totalGeral.marcas.findIndex((p) => marca.id === p.id);

    if (index < 0) {
      item = this.criarTotalizador(marca, marca.marca, marca.id);
      this.totalGeral.marcas.push(item);
    } else {
      item = this.totalGeral.marcas[index];
    }

    item.dados.forEach(element => {
      const posicao = marca.dados.findIndex((c) => c.id === element.id);
      const fat = marca.dados[posicao].total;
      element.total += fat;
    });
  }

  carregarTipos(marca: any): any {
    this.categorias = [];
    marca.dados.forEach(element => {
      this.categorias.push(element.nome);
    });
  }

  totalizarCategorias(marca: any) {
    let total = 0;
    let internas = 0;

    marca.dados.forEach(categoria => {
      total += categoria.total;
      internas += categoria.interna ? categoria.total : 0;
    });

    marca.total = total;
    marca.internas = internas;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  public definirFiltragem() {
    $('#rmpv-passagem-mensal-filtro').modal();
  }


  voltar() {
    this.router.navigateByUrl(this.obterUrlComFiltros());
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/passagem' + url;
  }

  getTranslate(value) {
    if (value == 'Motos usadas') {
      return value = this.translate.currentLang == 'br' ? 'Motos usadas' : 'Used motorcycles';
    } else if (value == 'Carros usados') {
      return value = this.translate.currentLang == 'br' ? 'Carros usados' : 'Used cars';
    }
    return this.objTranslateAPI[value];
  }

  getTranslateChart() {
    if (!this.dados) {
      return;
    }

    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        let labelsTranslateChart;
        if (!this.barChartLabelsCache.length) {
          this.barChartLabelsCache = Array.from(this.barChartLabels);
        }

        this.translate
          .stream(this.arrayTranslateChart.map(item => item.chave))
          .subscribe(value => {

            labelsTranslateChart = [];
            this.barChartLabelsCache.forEach(element => {

              this.arrayTranslateChart.forEach(item => {
                if (element === item.categoria) {
                  labelsTranslateChart.push(value[item.chave]);
                }
              });

            });
            this.barChartLabels = Array.from(labelsTranslateChart);

          }, error => console.log(error));
      });
  }


}
